import PlaylistItem from '../../models/playlistItem/playlistItem';
import Track from '../../models/track';
import { GlobalState } from '../_globalContext/context';
import { showLibraryErrors } from './libraryError';
import { ILibraryContext } from './libraryService';

export function createAddTracksToLibrary(ctx: GlobalState, library: ILibraryContext) {
  return function addTracksToLibrary(_addItems?: any) {
    return function (...items: Array<Track>) {
      showLibraryErrors(ctx.callSnackbar, () => library.addToLibrary(...items));
    };
  };
}
export function createAddItemsToPlaylistThenLibrary<T1>(
  ctx: GlobalState,
  libCtx: ILibraryContext,
  trackConstructor: (itm: T1) => Track,
) {
  return function addItemsThenToLibrary(addItems: (i: PlaylistItem[]) => void) {
    return function (...items: T1[]) {
      showLibraryErrors(ctx.callSnackbar, () => {
        const tracks = libCtx.addToLibrary(...items.map(trackConstructor));
        addItems(tracks.map(PlaylistItem.from));
      });
    };
  };
}

export default function createAddTracksToPlaylistThenLibrary(
  ctx: GlobalState,
  libCtx: ILibraryContext,
) {
  return function addTracksToPlaylistThenLibrary(addItems: (i: PlaylistItem[]) => void) {
    return function (...items: Array<Track>) {
      showLibraryErrors(ctx.callSnackbar, () => {
        const tracks = libCtx.addToLibrary(...items);
        addItems(tracks.map(PlaylistItem.from));
      });
    };
  };
}
